import { createLucideIcon } from "lucide-react";

export const UserAdd = createLucideIcon(
    "UserAdd",
    [
        [
            "path",
            {
                d: "M12.5 22H6.59087C5.04549 22 3.81631 21.248 2.71266 20.1966C0.453365 18.0441 4.1628 16.324 5.57757 15.4816C7.67837 14.2307 10.1368 13.7719 12.5 14.1052C13.3575 14.2261 14.1926 14.4514 15 14.7809",
                key: "7tq7xy",
            },
        ],
        [
            "path",
            {
                d: "M15 18.5H22",
                key: "6t7809",
            },
        ],
        [
            "path",
            {
                d: "M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z",
                key: "155e3c",
            },
        ],
        [
            "path",
            {
                d: "M18.5 22L18.5 15",
                key: "rn62rj",
            },
        ],
    ],
);
